import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef
} from "@angular/core";
import { environment } from "src/environments/environment";
import { NavigationMenuService, LoggingService, LoaderService } from "src/app/services";
import { Subscription } from "rxjs";
import { DocumentType, ITabs, IViewerParams, PlatForm, ViewerContentType } from "src/app/models";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DocumentViewerComponent } from "../document-viewer/document-viewer.component";
import { Router } from "@angular/router";
import moment from "moment";
import { Helpers } from "src/app/helpers";

@Component({
    selector: 'medpt-app-help',
    templateUrl: './app-help.component.html',
    styleUrls: ['./app-help.component.scss'],
    standalone: false
})
export class AppHelpComponent implements OnInit {
  private loadingIcon: string = '<div class="sm-loading text-center"></div>';
  version: string = this.loadingIcon;
  linkContent: string = this.loadingIcon;
  cdnEndPoint = environment.cdnEndPoint;

  constructor(
    private navigationMenuService: NavigationMenuService,
    private loggingService: LoggingService,
    private elRef: ElementRef,
    private loaderService: LoaderService,
    private modelDialogService: NgbModal,
    private router: Router) {
    if(Helpers.getPlatformId() == PlatForm.StudyStat){
        this.navigationMenuService.getStudyStatHelp().then((data) => {
        this.linkContent = data;
      });  
    }
    else if(Helpers.getPlatformId() == PlatForm.RaspberryAI){
        this.navigationMenuService.getRASPberryAIHelp().then((data) => {
        this.linkContent = data;
      });  
    }else{
       this.navigationMenuService.getHelp().then((data) => {
       this.linkContent = data;
      });
    }  
   

    this.navigationMenuService.getVersion().then((version) => {
      this.version = 'Release version - ' + version;
    });

  }

  ngOnInit(): void {}

  ngAfterViewChecked() {
    let anchorElms = this.elRef.nativeElement.querySelectorAll('#help-section a');
    if (anchorElms.length > 0) {
      for (let i = 0; i < anchorElms.length; i++) {
        anchorElms[i].onclick = (e: any) => {
          let docPath: string = e.target.getAttribute('data-doc-url');
          let vidPath: string = e.target.getAttribute('data-vid-url');
          let goToPath: string = e.target.getAttribute('data-goto');
          if (docPath != null) {
            docPath = docPath.replace('{cdnpath}', this.cdnEndPoint);
            let docTitle = <string>e.target.innerHTML;
            this.OpenDocViewer(docPath, docTitle);
          } else if (vidPath != null) {
            vidPath = vidPath.replace('{cdnpath}', this.cdnEndPoint);
            let vidTitle = <string>e.target.innerHTML;
            this.OpenVideoViewer(vidPath, vidTitle);
          } else if (goToPath != null) {
            var path = window.location.href;
            path = path.replace(/help/ig, goToPath).replace(window.location.origin, "");
            this.router.navigateByUrl(path);
          }
          e.preventDefault();
        }
      }
    }

    this.loaderService.hideLoader();
  }

  OpenDocViewer(docPath: string, docTtitle: string) {
    this.loaderService.showLoader();
    let params: IViewerParams = {
      DocumentUrl: docPath,
      ViewingSessionId: "",
      DownloadCallbackFunction: "",
      DownloadCallbackFunctionParam: "",
      Anontation: false,
      Download: true,
      Print: true
    };
    let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
    let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
    //let CONTENTURL = environment.viewerAppUrl + 'viewer/index?' + 'document=' + encodeURIComponent(docPath);
    let tabData: ITabs = { AssetId: 0, DocumentType: DocumentType.Certificate, contentUrl: CONTENTURL, name: docTtitle, showPlaceInRegDoc: false, showPrintButton: false, showSignButton: false, ViewerContentType: ViewerContentType.Document, viewerToken: queryParam };

    let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
    modalInstance.componentInstance.tabData = tabData;
    modalInstance.result.then((result) => { if (result) { } });
  }

  OpenVideoViewer(vidPath: string, docTtitle: string) {
    this.loaderService.showLoader();

    let CONTENTURL = vidPath;

    let tabData: ITabs = { AssetId: 0, DocumentType: DocumentType.Others, contentUrl: CONTENTURL, name: docTtitle, showPlaceInRegDoc: false, showPrintButton: false, showSignButton: false, ViewerContentType: ViewerContentType.Video, viewerToken: "" };

    let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
    modalInstance.componentInstance.tabData = tabData;
    modalInstance.result.then((result) => { if (result) { } });
  }

}
